module.exports = __webpack_public_path__ + "img/asian-noodles-1.f1c97b60.jpg";